// 3rd Party
import 'bootstrap/js/dist/carousel';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
library.add(
    faChevronLeft,
    faChevronRight
);
dom.watch();